const WEBSOCKET_LOCAL = "ws://10.10.18.222:8002";
const WEBSOCKET_PROD = process.env.REACT_APP_BACKEND_WEBSOCKET_URL;
const LOCAL_URL = process.env.REACT_APP_BACKEND_LOCAL_URL;
const PROD_URL = process.env.REACT_APP_BACKEND_PROD_URL;

const environments = {
  local: LOCAL_URL,
  prod: PROD_URL,
  websocket_local: WEBSOCKET_LOCAL,
  websocket_prod: WEBSOCKET_PROD,
};

const activeEnvironment = environments.prod;
const websocketactiveEnvironment = environments.websocket_prod;
// const spamActiveEnv = "http://192.168.3.179:8001";
const spamActiveEnv = "http://10.10.18.233:8003";
// const connectEmailUrl="http://192.168.3.209:8010"
const connectEmailUrl = "http://10.10.18.169:8003";

const apiEndpoints = {
  // auth api
  signUp: `${activeEnvironment}/signup`,
  login: `${activeEnvironment}/login`,
  verifyOtp: `${activeEnvironment}/verify-otp`,
  resendOtp: `${activeEnvironment}/resend-login-otp`,
  getMusicCreators: `${activeEnvironment}/get_music_creators`,
  updateUserProfile: `${activeEnvironment}/users/update-profile`,
  // sale person api
  submitRegistrationFrom: `${activeEnvironment}/requirements`,
  getsubmitedregistrationinfo: `${activeEnvironment}/requirements`,
  updateRequirementStatus: `${activeEnvironment}/requirements/status`,
  uploadAudioWithWatermark: `${activeEnvironment}/upload-with-watermark`,
  uploadAudioWithoutWatermark: `${activeEnvironment}/upload-without-watermark`,
  getWatermarkUploadedAudiobyId: `${activeEnvironment}/with-watermark-songs`,
  getfinalUploadedAudiobyId: `${activeEnvironment}/without-watermark-songs`,
  getAllWatermarkSongs: `${activeEnvironment}/songs-with-watermark`,
  getAllWithouWatermarkSongs: `${activeEnvironment}/songs-without-watermark`,
  getUserInfo: `${activeEnvironment}/get_user_info`,
  deleteJingleSong: `${activeEnvironment}/delete-song`,
  downloadSong: `${activeEnvironment}/download-song`,
  assignOrder: `${activeEnvironment}/orders/assign-order`,

  //orders
  getAllOrders: `${activeEnvironment}/orders`,
  getAllMusicCreatorOrders: `${activeEnvironment}/music-creator-orders`,
  getOrderById: `${activeEnvironment}/orders/{order_id}`,
  getClientOrderById: `${activeEnvironment}/client-orders/{order_id}`,
  changeOrderStatus: `${activeEnvironment}/orders/change-status`,
  createManualOrder: `${activeEnvironment}/orders/jingle`,
  approveWatermarkSong: `${activeEnvironment}/watermarked-jingles/approve`,
  dashboardCount: `${activeEnvironment}/dashboard-count`,
  editOrder: `${activeEnvironment}/orders/edit-order`,
  clientEditOrder: `${activeEnvironment}/orders/jingle/client-submit/{order_id}`,

  //admin
  adminDashboardCount: `${activeEnvironment}/admin-dashboard-count`,
  adminWeekOverview: `${activeEnvironment}/admin/last-7-days-status`,
  adminSalesPersonWeekOverview: `${activeEnvironment}/admin/sales-last-7-days-status/{user_pk}`,
  getAllSalesOrders: `${activeEnvironment}/admin/by-sales-person-order/{user_pk}`,
  usersList: `${activeEnvironment}/admin/users-grouped`,
  toggleUserActive: `${activeEnvironment}/admin/toggle-user-active`,

  //lyrics
  uploadLyrics: `${activeEnvironment}/orders/{order_id}/lyrics`,
  editLyrics: `${activeEnvironment}/orders/edit-lyrics`,
  approveLyrics: `${activeEnvironment}/orders/lyrics/approve`,
  getLyrics: `${activeEnvironment}/lyrics/{order_id}`,
  enableEditingLyrics: `${activeEnvironment}/orders/lyrics/unapprove`,
  addLyricsComment: `${activeEnvironment}/orders/lyrics/add-comment`,

  addWatermark: `${activeEnvironment}/watermark/add`,
  downloadWatermark: `${activeEnvironment}/watermark/download/{filename}`,
  downloadAllWatermark: `${activeEnvironment}/watermark/download-batch`,

  //collage
  createCollage: `${activeEnvironment}/create_order`,
  getAllCollage: `${activeEnvironment}/get_all_collage`,
  getCollageById: `${activeEnvironment}/get_collage/{order_id}`,
  downloadCollageById: `${activeEnvironment}/download-video/{order_id}`,

  //websocket
  sendMessage: `${websocketactiveEnvironment}/ws/group-chat?token={token}`,
  chatHistory: `${activeEnvironment}/group-chat/history`,

  //proforma invoice
  createProforma: `${activeEnvironment}/quotation/proforma-invoices`,
  downloadPdf: `${activeEnvironment}/quotation/proforma-invoices/{quotation_id}`,

  //manage category
  createCategory: `${activeEnvironment}/create_category`,
  getCategories: `${activeEnvironment}/get_categories`,
  getSongsByCategory: `${activeEnvironment}/get_songs_by_category/{category}`,
  deleteSong: `${activeEnvironment}/delete_songs/{category_id}/{sub_category}/{song_id}`,
  deleteCategory: `${activeEnvironment}/delete_category/{category_id}`,
  // getAllCategory: `${activeEnvironment}/get_all_categories`,
  addSongsToCategory: `${activeEnvironment}/add_songs_to_category`,
};

export { activeEnvironment, apiEndpoints, spamActiveEnv };
